import { render, staticRenderFns } from "./ConferenceManage.vue?vue&type=template&id=55302177&scoped=true"
import script from "./ConferenceManage.vue?vue&type=script&lang=js"
export * from "./ConferenceManage.vue?vue&type=script&lang=js"
import style0 from "./ConferenceManage.vue?vue&type=style&index=0&id=55302177&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55302177",
  null
  
)

export default component.exports